module.exports = __webpack_public_path__ + "static/img/MGtu6@2x.49ff992d.png";